<p-toast></p-toast>


<p-card styleClass="p-card-shadow" >
    <div class="dashboardTable">
        
        <p-table #miSurvey  [value]="tankAbstract"  dataKey="AppId_ProgID"
        [rows]="10"
        [paginator]="true" [globalFilterFields]="[
        'Srno',
		'Lot_No',
		'No_of_AllRecords',
		'Sum_of_AllRecords',
		'No_of_Successfull_Records',
		'Sum_of_Successfull_Records',
		'Sum_of_Failed_Records',
        'No_of_Failed_Records',
		'LotType',
		'Type',

        ]" responsiveLayout="scroll" [rowHover]="true" dataKey="Scheme_Specific_Id"
        currentPageReportTemplate="{{'SHOWING'| translate}} {first} {{'TO'| translate}} {last} {{'OF'| translate}} {totalRecords} {{'ENTRIES'| translate}}"
        [showCurrentPageReport]="true"
        (onFilter)="tableDataFunction($event)"
        (onPage)="onPage($event)" [loading]="loading">
        <ng-template pTemplate="caption">
            <div class="flex align-items-center justify-content-between">
                <h5 class="m-0">{{'LOT_REPORT'| translate}}</h5>
                <span>
                    <button  (click)="menu.toggle($event)" pButton pRipple label="{{'EXPORT' | translate}}" icon="pi pi-upload"
                    class="p-button-help"></button>
               
                <p-menu #menu [popup]="true" [model]="appVerificationItems" ></p-menu>
                </span>
                <span class="p-input-icon-left">
                    <i class="pi pi-search"></i>
                    <input pInputText type="text"
                        (input)="miSurvey.filterGlobal($any($event.target).value, 'contains')"
                        placeholder="{{'SEARCH'| translate}}" />
                </span>
            </div>
        </ng-template>
        <ng-template pTemplate="header">
            <tr>
                             
                <!-- <th pFrozenColumn pSortableColumn="Srno">{{'SR_NO'| translate}}
                    <p-columnFilter type="text" field="Srno" display="menu"></p-columnFilter>
                    <p-sortIcon field="Srno"></p-sortIcon>
                </th> -->
                <th pSortableColumn="Lot_No">{{'LOT_NO'| translate}}
                    <p-columnFilter type="text" field="Lot_No" display="menu"></p-columnFilter>
                    <p-sortIcon field="Lot_No"></p-sortIcon>
                </th>
                <th pSortableColumn="No_of_AllRecords">{{'NO_OF_RECORDS'| translate}}
                    <p-columnFilter type="text" field="No_of_AllRecords" display="menu"></p-columnFilter>
                    <p-sortIcon field="No_of_AllRecords"></p-sortIcon>
                </th>
                <th pSortableColumn="Sum_of_AllRecords">{{'SUM_OF_RECORDS'| translate}}
                    <p-columnFilter type="text" field="Sum_of_AllRecords" display="menu"></p-columnFilter>
                    <p-sortIcon field="Sum_of_AllRecords"></p-sortIcon>
                </th>
                <th pSortableColumn="No_of_Successfull_Records">{{'NO_OF_SUCCESSFULL_RECORDS'| translate}}
                    <p-columnFilter type="text" field="No_of_Successfull_Records" display="menu"></p-columnFilter>
                    <p-sortIcon field="No_of_Successfull_Records"></p-sortIcon>
                </th>
                <th pSortableColumn="Sum_of_Successfull_Records">{{'SUM_OF_SUCCESSFULL_RECORDS'| translate}}
                    <p-columnFilter type="text" field="Sum_of_Successfull_Records" display="menu"></p-columnFilter>
                    <p-sortIcon field="Sum_of_Successfull_Records"></p-sortIcon>
                </th>
                <th pSortableColumn="Sum_of_Failed_Records">{{'SUM_OF_FAILED_RECORDS'| translate}}
                    <p-columnFilter type="text" field="Sum_of_Failed_Records" display="menu"></p-columnFilter>
                    <p-sortIcon field="Sum_of_Failed_Records"></p-sortIcon>
                </th>
                <th pSortableColumn="No_of_Failed_Records">{{'NO_OF_FAILED_RECORDS'| translate}}
                    <p-columnFilter type="text" field="No_of_Failed_Records" display="menu"></p-columnFilter>
                    <p-sortIcon field="No_of_Failed_Records"></p-sortIcon>
                </th>
                <th pSortableColumn="LotType">{{'LOT_TYPE'| translate}}
                    <p-columnFilter type="text" field="LotType" display="menu"></p-columnFilter>
                    <p-sortIcon field="LotType"></p-sortIcon>
                </th>
                <th pSortableColumn="Type">{{'TYPE'| translate}}
                    <p-columnFilter type="text" field="Type" display="menu"></p-columnFilter>
                    <p-sortIcon field="Type"></p-sortIcon>
                </th>
            
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-tankAbstract>
            <tr>
                <!-- <td pFrozenColumn>{{tankAbstract.Srno}}</td> -->
                <td>{{tankAbstract.Lot_No}}</td>
                <td>{{tankAbstract.No_of_AllRecords}}</td>
                <td>{{tankAbstract.Sum_of_AllRecords}}</td>
                <td>{{tankAbstract.No_of_Successfull_Records}}</td>
                <td>{{tankAbstract.Sum_of_Successfull_Records}}</td>
                <td>{{tankAbstract.Sum_of_Failed_Records}}</td>
                <td>{{tankAbstract.No_of_Failed_Records}}</td>
                <td>{{tankAbstract.LotType}}</td>
                <td>{{tankAbstract.Type}}</td>
                
            </tr>
        </ng-template>
        <!-- <ng-template pTemplate="footer">
            <tr>
                <td >  Total</td>
                <td >{{tankApp | number:'1.0-2'}}</td>
                <td >{{tankCoverageArea | number:'1.0-2'}}</td>
                <td >{{tankVerifiedApp | number:'1.0-2'}}</td>
                <td >{{tankRpApp | number:'1.0-2'}}</td>
                <td >{{tankRejectedApp | number:'1.0-2'}}</td>
                <td >{{tankVerifiedCoverageApp | number:'1.0-2'}}</td>
            </tr>
            <tr>
                <td > Grand Total</td>
                <td >{{grandTankApp | number:'1.0-2'}}</td>
                <td >{{grandTankCoverageArea | number:'1.0-2'}}</td>
                <td >{{grandTankVerifiedApp | number:'1.0-2'}}</td>
                <td >{{grandTankRpApp | number:'1.0-2'}}</td>
                <td >{{grandTankRejectedApp | number:'1.0-2'}}</td>
                <td >{{grandTankVerifiedCoverageApp | number:'1.0-2'}}</td>
            </tr>
        </ng-template> -->
    
        </p-table>
    </div>
    </p-card>
    